export default "__VITE_ASSET__40e5e355__"